import {
  HealthDiaryPathsEnum,
  HealthDiaryRoutesEnum,
} from "@ch/router/HealthDiaryRoutes/enums.ts";
import HRVLogPageLazy from "@ch/pages/HRVPage/HRVLogPageLazy.tsx";
import HRVHistoryPageLazy from "@ch/pages/HRVPage/HRVHistoryPageLazy.tsx";
import HRVPageLazy from "@ch/pages/HRVPage";
import postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import FeatureFlagRouteGate from "@ch/components/Gate/FeatureFlagRouteGate.tsx";

export const hrvRoutes = [
  {
    path: HealthDiaryPathsEnum.HRV_HISTORY,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <HRVHistoryPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "HRV History",
      }),
      crumb: () => ({
        title: "HRV History",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_HRV_HISTORY,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.HRV_LOG,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <HRVLogPageLazy />
      </FeatureFlagRouteGate>
    ),

    handle: {
      meta: () => ({
        title: "HRV Log",
      }),
      crumb: () => ({
        title: "Log HRV",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_HRV_LOG,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.HRV,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <HRVPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "HRV",
      }),
      crumb: () => ({
        title: "HRV",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_HRV,
      }),
    },
  },
];
